<template>
<div class="start-view">
    <div class="logo">
        <img v-if="$i18n.locale == 'se'" src="img/kunniakierros-logo-se.png" />
        <img v-else src="img/kunniakierros-logo-fi.png" />
    </div>
    <div>
        <router-link to="/login">
            <button class="button button-green">
                {{ $t("startView.login") }}
            </button>
        </router-link>
    </div>
    
    <div>
        <router-link to="/about">
            <button class="button button-green">
                {{ $t("startView.about") }}
            </button>
        </router-link>
    </div>

    <div class="footer-text">
        <div>{{ $t("startView.footerText") }}</div>
    </div>

    <div class="locale-chooser">
        <a href="" @click.prevent="setLocale('fi')" :class="{ disabled: $i18n.locale == 'fi' }">Suomeksi</a>
        <span> - </span>
        <a href="" @click.prevent="setLocale('se')" :class="{ disabled: $i18n.locale == 'se' }">På svenska</a>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { store } from "store";

export default defineComponent({
    mounted() {
        store.page.title = this.$t("startView.title") as string;
        store.page.showTopNav = false;
    },
    setup() {
        const { locale } = useI18n();

        const setLocale = (newLocale: string) => {
            locale.value = newLocale;
        };

        return {
            store,
            setLocale,
        };
    }
});
</script>